module.exports = __webpack_public_path__ + "img/TRUSTe_certified_privacy_en.d7aa049e.png";